<div class="stories">
	@if (stories$ | async; as stories) {
		<!-- todo: для десктопа нужен будет слайдер -->
		<!-- <app-tiny-slider
    [sliderConfig]="sliderConfig"
    class="tiny-slider--with-small-arrows"
    >
  </app-tiny-slider> -->

		@for (story of stories; track story; let i = $index) {
			<button
				class="stories-slider__item"
				type="button"
				#story
				[attr.story-id]="story.storyId"
			>
				<app-story
					class="stories__story"
					[story]="story"
					(storyClick)="
						story.isSlidesEnabled && story.slides?.length && handleStoryClick($event, i)
					"
				></app-story>
			</button>
		}
	} @else {
		<div class="stories__skeleton-loading">
			@for (item of [1, 2, 3, 4]; track item) {
				<span class="stories__skeleton-item"></span>
			}
		</div>
	}
</div>
